import { useTranslation } from 'react-i18next';
import { Lock, Check } from 'lucide-react';

export function PrivacySpotlight() {
  const { t } = useTranslation();

  const bullets = [t('home.privacy.bullet1'), t('home.privacy.bullet2'), t('home.privacy.bullet3')];

  return (
    <section className="relative overflow-hidden border-t border-border bg-gradient-to-br from-emerald-50/70 via-white to-teal-50/70 dark:from-emerald-950/30 dark:via-slate-950/40 dark:to-teal-950/30">
      <div aria-hidden className="pointer-events-none absolute inset-0">
        <div className="absolute -left-20 top-1/2 size-[460px] -translate-y-1/2 rounded-full bg-emerald-400/20 blur-[120px] dark:bg-emerald-500/15" />
        <div className="absolute right-0 top-1/4 size-[400px] rounded-full bg-teal-400/15 blur-[120px] dark:bg-teal-500/10" />
      </div>

      <div className="relative mx-auto max-w-6xl px-4 py-16 md:py-24">
        <div className="grid items-center gap-10 md:grid-cols-2 md:gap-16">
          <div className="relative mx-auto w-full max-w-sm md:max-w-none">
            <div className="relative flex aspect-square items-center justify-center">
              <div
                aria-hidden
                className="absolute inset-8 animate-pulse rounded-full bg-emerald-400/25 blur-3xl"
              />
              <div
                aria-hidden
                className="absolute inset-16 rounded-full border border-emerald-400/30"
              />
              <div
                aria-hidden
                className="absolute inset-24 rounded-full border border-emerald-400/40"
              />
              <div className="relative inline-flex size-40 items-center justify-center rounded-[2rem] border border-emerald-400/40 bg-gradient-to-br from-emerald-400 via-emerald-500 to-teal-600 text-white shadow-2xl shadow-emerald-500/40">
                <Lock className="h-16 w-16 drop-shadow-lg" strokeWidth={1.75} />
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-5">
            <p className="text-sm font-semibold uppercase tracking-wider text-emerald-600 dark:text-emerald-400">
              {t('home.privacy.eyebrow')}
            </p>
            <h2 className="font-display text-3xl font-extrabold tracking-tight md:text-4xl">
              {t('home.privacy.title')}
            </h2>
            <p className="text-base text-muted-foreground md:text-lg">
              {t('home.privacy.subtitle')}
            </p>
            <ul className="mt-2 space-y-3">
              {bullets.map((text) => (
                <li key={text} className="flex items-start gap-3">
                  <span className="mt-0.5 inline-flex size-5 shrink-0 items-center justify-center rounded-full bg-emerald-500/15 text-emerald-600 ring-1 ring-emerald-500/25 dark:text-emerald-400">
                    <Check className="h-3 w-3" strokeWidth={3} />
                  </span>
                  <span className="text-sm md:text-base">{text}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
